import { ChartNoAxesCombined, CreditCard, FileWarning, LifeBuoy, ShieldBan, UsersRound } from "lucide-react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

const adminNavItems = [
  {
    icon: UsersRound,
    labelKey: "adminWorkspace.sidebar.users",
    to: "/admin/users",
  },
  {
    icon: CreditCard,
    labelKey: "adminWorkspace.sidebar.credits",
    to: "/admin/credits",
  },
  {
    icon: ShieldBan,
    labelKey: "adminWorkspace.sidebar.bans",
    to: "/admin/bans",
  },
  {
    icon: LifeBuoy,
    labelKey: "adminWorkspace.sidebar.pqr",
    to: "/admin/pqr",
  },
  {
    icon: FileWarning,
    labelKey: "adminWorkspace.sidebar.logs",
    to: "/admin/logs",
  },
  {
    icon: ChartNoAxesCombined,
    labelKey: "adminWorkspace.sidebar.analytics",
    to: "/admin/analytics",
  },
] as const;

export function AdminSidebar() {
  const { t } = useTranslation();

  return (
    <aside className="rounded-[2rem] border border-[#7f6c54]/30 bg-[linear-gradient(180deg,rgba(20,17,14,0.98),rgba(35,28,22,0.96))] p-4 text-[#f8f1e8] shadow-[0_30px_80px_-34px_rgba(0,0,0,0.7)]">
      <div className="rounded-[1.6rem] border border-white/10 bg-white/5 px-4 py-5">
        <p className="text-[11px] font-semibold uppercase tracking-[0.34em] text-[#d2b793]">
          {t("adminWorkspace.sidebar.eyebrow")}
        </p>
        <h2 className="mt-3 font-display text-3xl leading-none text-[#fff7ef]">
          {t("adminWorkspace.sidebar.title")}
        </h2>
        <p className="mt-3 text-sm leading-6 text-[#dccfbe]/78">
          {t("adminWorkspace.sidebar.subtitle")}
        </p>
      </div>

      <nav className="mt-4 space-y-2">
        {adminNavItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => (
                `group flex items-center gap-3 rounded-[1.35rem] px-4 py-3 text-sm transition ${
                  isActive
                    ? "bg-[#e8c59b] text-[#21160f] shadow-[0_18px_35px_-24px_rgba(232,197,155,0.9)]"
                    : "text-[#f0e3d1]/78 hover:bg-white/8 hover:text-[#fff7ef]"
                }`
              )}
            >
              {({ isActive }) => (
                <>
                  <span className={`inline-flex size-10 items-center justify-center rounded-full border ${
                    isActive
                      ? "border-[#21160f]/10 bg-[#21160f]/8"
                      : "border-white/10 bg-white/5"
                  }`}>
                    <Icon className="size-4" />
                  </span>
                  <span className="font-semibold tracking-[0.02em]">{t(item.labelKey)}</span>
                </>
              )}
            </NavLink>
          );
        })}
      </nav>

      <div className="mt-6 rounded-[1.5rem] border border-white/10 bg-black/20 px-4 py-4 text-sm leading-6 text-[#d8c8b3]/72">
        {t("adminWorkspace.sidebar.footnote")}
      </div>
    </aside>
  );
}
